import {toCamelCaseProperties} from '@/utils/fn';
import {VisitedSite} from "@/services/models";

export default class WebshopSetting {
   constructor(args) {
      args = toCamelCaseProperties(args) || {};
      this.id = args.id || 0;
      this.active = args.active || false;
      this.chainLogoUrl = args.chainLogoUrl || '';
      this.chainHomePageUrl = args.chainHomePageUrl || '';
      this.chainName = args.chainName || '';
      this.hasGiftcard = args.hasGiftcard || false;
      this.hasBooking = args.hasBooking || false;
      this.preperationTime = args.preperationTime;
      this.maxReservationDays = args.maxReservationDays;
      this.activatedSalons = (args.activatedSalons || []).map(site => {
         site = toCamelCaseProperties(site) || {};
         return new VisitedSite({
            hasBooking: site.hasBooking || false,
            mapLatitude: site.mapLatitude || '',
            mapLongitude: site.mapLongitude || '',
            siteId: site.siteId || 0,
            fixitSiteId: site.fixitSiteId || '',
            chainId: site.chainId || 0,
            siteName: site.name || '',
            address: site.address || '',
            postalArea: site.postalArea || '',
            postalCode: site.postalCode || '',
            openingHours: [{
               dayNumber: '',
               from: '',
               to: '',
               openByAppointment: false,
               siteId: '',
               isOpen: false
            }],
            imageUrl: site.imageLocation || '',
            urlLink: site.urlLink,
            urlFrendlyLink: site.urlFrendlyLink,
            homeShipmentEnabled: site.homeShipmentEnabled

         })
      });
   }
}
